var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('footer', [!_vm.showOnlyDisclosure ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "group company"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm.showBlackLogo ? _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/images/extra-logo-black.svg"),
      "alt": "Extra logo"
    }
  }) : _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/images/extra-logo-white.svg"),
      "alt": "Extra logo"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("\n\t\t\t\t© " + _vm._s(_vm.year) + " The Aligned Company "), _c('br'), _vm._v("\n\t\t\t\td./b./a. Extra"), _c('br'), _vm._v("\n\t\t\t\tNMLS #2341556\n\t\t\t")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "link-group"
  }, [_c('h4', [_vm._v("Product")]), _vm._v(" "), _c('ul', {
    staticClass: "links"
  }, [_c('li', {
    staticClass: "link"
  }, [_c('a', {
    on: {
      "click": () => _vm.onSignupClick('footer', 'apply')
    }
  }, [_vm._v("Apply")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', {
    staticClass: "link"
  }, [_c('nuxt-link', {
    attrs: {
      "to": "/download"
    }
  }, [_vm._v("Download")])], 1), _vm._v(" "), _c('li', {
    staticClass: "link"
  }, [_c('nuxt-link', {
    attrs: {
      "to": "/members"
    }
  }, [_vm._v("Members Area")])], 1), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "link-group"
  }, [_c('h4', [_vm._v("Company")]), _vm._v(" "), _c('ul', {
    staticClass: "links"
  }, [_c('li', {
    staticClass: "link"
  }, [_c('nuxt-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Contact Us")])], 1), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)]) : _vm._e(), _vm._v(" "), _vm.showDefaultDisclosure ? _c('div', {
    staticClass: "disclosure"
  }, [_c('p', [_c('sup', [_vm._v("1")]), _vm._v("The Aligned Company d/b/a Extra (“Extra”) is a technology company, not a bank.\n\t\t\tThe Extra Debit Card is issued by Evolve Bank & Trust or Patriot Bank N.A. (Member FDIC),\n\t\t\tpursuant to a license by Mastercard International. Line of credit provided by Lead Bank.\n\t\t\tThis Card can be used everywhere Debit Mastercard is accepted. Extra is responsible for\n\t\t\tcredit reporting and reports on time and late payments, which may impact a credit bureau’s\n\t\t\tdetermination of your credit score. Credit scores are independently determined by credit\n\t\t\tbureaus based on a number of factors, including your other financial transactions. Extra\n\t\t\treports to Experian® and Equifax®. The Extra Debit Card and related services will not remove\n\t\t\tnegative credit history from your credit report. Rewards points only available with rewards\n\t\t\tplan. Membership fees apply. Please refer to our\n\t\t\t"), _c('a', {
    staticClass: "underline",
    attrs: {
      "href": "/legal/terms"
    }
  }, [_vm._v("Terms of Service")]), _vm._v(" and\n\t\t\t"), _c('a', {
    staticClass: "underline",
    attrs: {
      "href": "/legal/cardholder-agreement"
    }
  }, [_vm._v("Cardholder Agreement")]), _vm._v(" for\n\t\t\tadditional details.\n\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('sup', [_vm._v("2")]), _vm._v("To transact with your Extra Debit Card, you must have an active,\n\t\t\tPlaid-compatible bank account linked to Extra’s services (“Partner Account”). If your\n\t\t\tPartner Account is disconnected from Extra services for any reason, you will not be able to\n\t\t\tuse your Extra Debit Card. Within 30 days of the date of each transaction made using your\n\t\t\tExtra Debit Card, Extra will initiate one or more ACH debits to deduct equivalent funds from\n\t\t\tyour Partner Account. These ACH debits typically deduct funds from your Partner Account\n\t\t\twithin 2 to 3 business days after initiation by Extra.\n\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('sup', [_vm._v("3")]), _vm._v("Data based on a study of active Extra customers with good credit habits.\n\t\t\tIndividual results may vary. To learn more, please see the full study at\n\t\t\t"), _c('a', {
    staticClass: "underline",
    attrs: {
      "href": "/study"
    }
  }, [_vm._v("extra.app/study")]), _vm._v(".\n\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\tTHIS IS A LOAN SOLICITATION ONLY. THE ALIGNED COMPANY IS NOT THE LENDER. INFORMATION\n\t\t\tRECEIVED WILL BE SHARED WITH ONE OR MORE THIRD PARTIES IN CONNECTION WITH YOUR LOAN INQUIRY.\n\t\t\tTHE LENDER MAY NOT BE SUBJECT TO ALL VERMONT LENDING LAWS. THE LENDER MAY BE SUBJECT TO\n\t\t\tFEDERAL LENDING LAWS.\n\t\t\t"), _vm.showOnlyDisclosure ? [_c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tNMLS #2341556\n\t\t\t")] : _vm._e()], 2)]) : _c('div', {
    staticClass: "disclosure"
  }, [_c('sanity-block-content', {
    staticClass: "custom-disclosure",
    attrs: {
      "blocks": _vm.footerDisclosure
    }
  })], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('p', {
    staticClass: "mt-4"
  }, [_vm._v("Contact Us: "), _c('a', {
    attrs: {
      "href": "mailto:hey@extra.app"
    }
  }, [_vm._v("hey@extra.app")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "divider"
  }, [_c('div', {
    staticClass: "fill"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "/blog"
    }
  }, [_vm._v("Blog")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "/help"
    }
  }, [_vm._v("Support Center")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "https://boards.greenhouse.io/extra",
      "target": "blank"
    }
  }, [_vm._v("Careers")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "link-group"
  }, [_c('h4', [_vm._v("Resources")]), _vm._v(" "), _c('ul', {
    staticClass: "links"
  }, [_c('li', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "/legal/privacy"
    }
  }, [_vm._v("Privacy Policy")])]), _vm._v(" "), _c('li', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "/legal/terms"
    }
  }, [_vm._v("Terms of Service")])]), _vm._v(" "), _c('li', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "/legal"
    }
  }, [_vm._v("Legal Documents")])])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "link-group"
  }, [_c('h4', [_vm._v("Follow")]), _vm._v(" "), _c('ul', {
    staticClass: "links"
  }, [_c('li', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/extra.card/"
    }
  }, [_vm._v("Instagram")])]), _vm._v(" "), _c('li', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/extracard"
    }
  }, [_vm._v("Twitter")])]), _vm._v(" "), _c('li', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "https://www.tiktok.com/@extra.card"
    }
  }, [_vm._v("TikTok")])])])]);
}];
export { render, staticRenderFns };